import React from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import SquareCardPayment from "../Payment/SquareCardPayment";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import "./../style/common.css"
import { useEffect } from "react";



const CreatePaymentPage = () => {
  const navigate = useNavigate();

  // Get total from localStorage (or recompute)
  const storedPayload = localStorage.getItem("pending_order_payload");
  const payload = storedPayload ? JSON.parse(storedPayload) : null;

  const amount = payload?.final_amount ? parseFloat(payload.final_amount) : 0;

  if (!payload) {
    message.error("No order found. Please go back to Cart.");
    navigate("/cart");
    return null;
  }

  

  return (
    <>
      <BreadcrumbBanner title="Payment" backgroundImage="/Images/banner-about.jpg" />
      <div className="payment-page-wrapper">
        <div className="payment-card">
          <h3 style={{ marginBottom: 20 }}>Complete Your Payment</h3>
          <SquareCardPayment
            amount={amount}
            orderId={null}
            onSuccess={() => {
              message.success("Payment and Order Complete");

              // Cleanup
              localStorage.removeItem("pending_order_payload");
              localStorage.removeItem("quick_user_info");
              localStorage.removeItem("quick_user_address1");
              localStorage.removeItem("quick_user_address2");
              localStorage.removeItem("mandurah_delivery_charge");
              localStorage.removeItem("mandurah_delivery_distance");
              localStorage.removeItem("delivery_distance_km");

              navigate("/thank-you");
            }}
          />
        </div>
      </div>
    </>
  );
};

export default CreatePaymentPage;
